module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/27.e86b49b4.jpg";